import { useQuery } from '@tanstack/react-query'

import { getTemplates } from '@pepper/utils/src/api/editor-templates/editor-templates'

interface Parameter {
  data: {
    companyId: string
    includePepperTemplate?: number
  }
}

async function handleApiRequest(parameter: Parameter['data']) {
  const result = await getTemplates(parameter)
  if (result.status !== 'ok') {
    throw new Error(result.error)
  }

  return result.data
}

// TODO: use this hook on all instances of getTemplates
function useGetTemplates({ data }: Parameter) {
  return useQuery({
    queryFn: () => handleApiRequest(data),
    queryKey: ['templates', data.companyId]
  })
}

export default useGetTemplates
